// extracted by mini-css-extract-plugin
export var closeButton = "_f0-1";
export var closeX = "_f0-3";
export var container = "_f0-0";
export var image = "_f0-2";